import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aca717a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "观众参与名单", -1))
const _hoisted_4 = { class: "drawer_content" }
const _hoisted_5 = { class: "drawer_action_group" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "drawer_list" }
const _hoisted_8 = {
  class: "list_roll",
  id: "scroll"
}
const _hoisted_9 = { class: "drawer_footer" }
const _hoisted_10 = { class: "btn_group" }

import { computed, reactive, ref, unref, onMounted } from 'vue';
import CDelModal from '@/components/CDelModal.vue';
import { message, notification, Table } from 'ant-design-vue';
import { MemberList } from './lottery';
import http from '@/api';
import router from '@/router';
import { getCurrentInstance } from 'vue';
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import https from '@/api/exportList';


export default /*#__PURE__*/_defineComponent({
  __name: 'AudienceList',
  props: {
    dataSource: null
  },
  emits: ['click:callbackSecPage'],
  setup(__props: any, { emit }) {

const props = __props as { dataSource: any };

const aTable = Table;

const onBlack = () => {
  emit('click:callbackSecPage');
};
const studioId = router.currentRoute.value.params.studioId;

const userList = ref<MemberList[]>([]);
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 20, // 每页条数
  totalSize: 0, // 总页数
});
const getUserList = useDebounce(() => {
  // 名单类型 0.本地名单 1.观众参与名单 2.全部名单
  const data: any = {
    studio_id: studioId,
    keywords: '',
    type: 1,
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery.getMemberListNew({ params: data }).then((res) => {
      userList.value.push(...res.data.data.data);
      pageConfig.totalSize = res.data.data.total || 0;
      pageConfig.current++;
    });
  } else {
    http.lottery.getMemberList({ params: data }).then((res) => {
      userList.value.push(...res.data.data.data);
      pageConfig.totalSize = res.data.data.total || 0;
      pageConfig.current++;
    });
  }
});
getUserList();

//滚动加载数据
const handleScroll = () => {
  //窗口滚要做的操作写这里
  let sh = document.getElementById('scroll')?.scrollHeight || document.body.scrollHeight; // 内容可视区域的高度加上溢出（滚动）的距离
  let st = document.getElementById('scroll')?.scrollTop || document.body.scrollTop; // 滚动条距离顶部的距离
  let ch = document.getElementById('scroll')?.clientHeight || document.body.clientHeight; // 内容可视区域的高度
  // console.log('sh-%s---st-%s----ch-%s', sh, st, ch);
  if (st + ch >= sh - 100) {
    //快到底时----加载
    if (pageConfig.totalSize && userList.value.length < pageConfig.totalSize) {
      getUserList(); // 加载数据的方法
    }
  }
};
// 滚动事件
onMounted(() => {
  //监听页面滚动事件
  document.getElementById('scroll')?.addEventListener('scroll', handleScroll);
});

const columns = [
  {
    title: '观众姓名',
    dataIndex: 'realname',
    align: 'left',
  },
  {
    title: '观众信息',
    dataIndex: 'mobile',
    align: 'center',
  },
];

const selectedRowKeys = ref<string[]>([]);
selectedRowKeys.value = [];
const onSelectChange = (changableRowKeys: string[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});

// 删除
const delModal = reactive<any>({
  title: '提示',
  visible: false,
  all: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const openDelAll = () => {
  delModal.all = !delModal.all;
};

const delUserList = () => {
  openDelModal();
  const data: any = {
    studio_id: studioId,
    ids: selectedRowKeys.value.join(','),
  };
  if (props.dataSource.drawType == 2) {
    // 活动抽奖
    data.draw_new_id = props.dataSource.drawId;
    http.lottery
      .delMemberListNew(data)
      .then((res) => {
        message.success(res.data.message);
        userList.value = [];
        pageConfig.current = 1;
        getUserList();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else {
    http.lottery
      .delMemberList(data)
      .then((res) => {
        message.success(res.data.message);
        userList.value = [];
        pageConfig.current = 1;
        getUserList();
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

// 一键删除
const delAllList = () => {
  const data = {
    studio_id: studioId,
    type: props.dataSource.drawType === 2 ? 2 : 1,
    kind: 2, //1全部名单 2观众名单 3本地名单
    draw_new_id: props.dataSource.drawType === 2 ? props.dataSource.drawId : '',
  };
  http.lottery
    .delAllList(data)
    .then((res) => {
      message.success(res.data.message);
      openDelAll();
      userList.value = [];
      pageConfig.current = 1;
      getUserList();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

// 抽奖 名单管理 导出
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref()
const drawExport = useDebounce((type: number, listType: number) => {
  if (props.dataSource.drawType === 2) {
    type = 35;
    const data = {
      studio_id: studioId,
      type: type,
      is_cron_download: corn.value,
      list_type: listType,
      draw_new_id: props.dataSource.drawId,
    };
    https
      .excel_regional_distribution({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error
        openNotificationWithIcon('error');
      });
  } else {
    type = 18;
    const data = {
      studio_id: studioId,
      type: type,
      is_cron_download: corn.value,
      list_type: listType,
    };
    https
      .excel_regional_distribution({ params: data })
      .then((res: any) => {
        messageTip.value = res.data.message;
        openNotificationWithIcon('success');
      })
      .catch((res: any) => {
        messageTip.value = res.data.error
        openNotificationWithIcon('error');
      });
  }
  // 1 全部  2 观看量排名  3 设备占比  4 观看途径  5 访问来源  6 榜单排行  7 观看流水
  // 8 群聊记录 9 私聊记录  10 邀约码  11 直播间付费记录  12 表单用户信息 16 在线观众分布  18抽奖名单
  // list_type 抽奖名单类型 0.本地名单 1.观众参与 2.全部名单
});

// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        type: "link",
        class: "drawer_title_back",
        onClick: onBlack
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回>>")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            class: "drawer_action_btn",
            disabled: selectedRowKeys.value.length == 0,
            onClick: openDelModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("删除")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            class: "drawer_action_btn",
            disabled: userList.value.length == 0,
            onClick: openDelAll
          }, {
            default: _withCtx(() => [
              _createTextVNode("一键删除")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("span", _hoisted_6, "已参与: " + _toDisplayString(userList.value.length) + "人", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(aTable), {
            "row-selection": _unref(rowSelection),
            columns: columns,
            "data-source": userList.value,
            pagination: false,
            "row-key": 
          (res) => {
            return res.id;
          }
        
          }, null, 8, ["row-selection", "data-source", "row-key"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(drawExport)(18, 1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出记录")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      ok: delUserList,
      close: openDelModal
    }, null, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: delModal.all,
      centered: "",
      ok: delAllList,
      close: openDelAll
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将删除列表全部信息，是否继续？")
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})